export {
    TutorSettingsGeneralPage,
    type TutorGeneralSettingsField,
    type TutorSettingsGeneralPageProps,
} from "./TutorSettingsGeneralPage"
